import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as alumniApi from '../../api/alumniApi';

export const subscribeAlumni = createAsyncThunk(
  'alumni/subscribe',
  async (payload, { rejectWithValue }) => {
    try {
      return await alumniApi.subscribeAlumni(payload);
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || 'Erreur lors de l\'inscription.');
    }
  }
);

export const fetchAlumni = createAsyncThunk(
  'alumni/fetch',
  async (params = {}, { rejectWithValue }) => {
    try {
      return await alumniApi.fetchAlumni(params);
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || 'Erreur lors du chargement.');
    }
  }
);

const alumniSlice = createSlice({
  name: 'alumni',
  initialState: {
    list: [],
    loading: false,
    error: null,
    subscribeSuccess: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearSubscribeSuccess: (state) => {
      state.subscribeSuccess = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(subscribeAlumni.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(subscribeAlumni.fulfilled, (state, action) => {
        state.loading = false;
        state.subscribeSuccess = action.payload;
      })
      .addCase(subscribeAlumni.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchAlumni.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAlumni.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload || [];
      })
      .addCase(fetchAlumni.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearError, clearSubscribeSuccess } = alumniSlice.actions;
export default alumniSlice.reducer;
